import React from 'react'

function TakeControl() {
  return (
    <section className="w-full flex flex-col justify-center items-center lg:px-10">
      <h1 className="text-center font-bold font-nunito text-xl md:text-3xl text-white ">
      Take control of your data, and earn money with our comprehensive marketplace
      </h1>
      <div className="my-7 flex flex-col items-center ">

      <div className="md:w-[90%] lg:w-[80%] grid grid-cols-1 md:grid-cols-4 gap-4 ">

       <div className="p-6 transition-all duration-300">
         <p className="text-white">
           1.<b>Use our platform</b>. The more you engage with our platform, the more value your data has.
         </p>
      </div>

      <div className="p-6 transition-all duration-300">
      <p className="text-white">
         2.<b>Allow us to sell your data</b>. Once we have your permission, your data is anonymously packaged with other user data and sold through our marketplace.
       </p>
      </div>

      <div className="p-6 transition-all duration-300">
      <p className="text-white">
         3.<b>Profit</b>. Every time a dataset is purchased that you contributed to, you get a percentage of the sales.
       </p>
       </div>

       <div className="p-6 transition-all duration-300">
         <p className="text-white">
         4.<b>Repeat</b>. We want to make this experience as easy as possible for you. Just continue using the platform and watch as your data earns you money.
       </p>
       </div>

      </div>

      <div className="hidden md:flex md:w-[90%] lg:w-[80%]  justify-around ">
      <div className="h-20 w-2 bg-[#211E1E] rounded-tl-xl rounded-tr-xl"/>
      <div className="h-20 w-2 bg-[#211E1E] rounded-tl-xl rounded-tr-xl"/>
      <div className="h-20 w-2 bg-[#211E1E] rounded-tl-xl rounded-tr-xl"/>
      <div className="h-20 w-2 bg-[#211E1E] rounded-tl-xl rounded-tr-xl"/>
      </div>

      <div className="md:w-[90%] lg:w-[80%] h-2 bg-black text-black shadow-black"/>

      <div className="p-2 md:p-5 my-10">
        <p className="text-white lg:text-center md:text-xl mt-2 font-nunito font-medium">
        Millions of companies are profiting off of your data everyday. We believe that transparency is the key to a better future and at OpenPolitica, we want to give the control of your data back to you. We provide you with the opportunity to make money off of your data through an easy to use data marketplace.
        </p>
      </div>

      </div>
    </section>


  )
}

export default TakeControl
